/**
 * Round a monetary amount to 2 decimal places (sen). Use this instead of `Math.round` for any
 * value that represents money — plain `Math.round` snaps to whole ringgit and silently drops the
 * cents (e.g. a percentage deposit like 50% of RM 12,345.67 → 6172.835 would display as RM 6,173).
 * The `* 100 … / 100` keeps the two decimal places; `+ 0` normalises `-0` to `0`.
 */
export function round2(n: number): number {
  return Math.round((n || 0) * 100) / 100 + 0;
}

/**
 * Format a number as ringgit with exactly 2 decimal places (sen), e.g. 3227.5 → 'RM 3,227.50',
 * 5000 → 'RM 5,000.00'. Every price/deposit surface must show cents — never a bare
 * `.toLocaleString()`, which drops trailing zeros (3227.5) and hides the sen entirely (5000).
 */
export function fmtRM(n: number | null | undefined): string {
  return 'RM ' + (n || 0).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Just the number part, 2 decimals: 3227.5 → '3,227.50'. Use when the 'RM ' prefix is added separately. */
export function fmtAmount(n: number | null | undefined): string {
  return (n || 0).toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
